<template>
  <div>
    <v-container v-if="!loading" class="py-10">
      <v-card class="mx-auto">
        <v-card-title>Medicine</v-card-title>

        <v-card-text>
          <v-container fluid>
            <v-form ref="form">
              <v-row>
                <v-col>
                  <v-switch
                    v-model="medicine.is_pndf"
                    label="Is PNDF"
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <v-autocomplete
                    v-if="medicine.is_pndf"
                    v-model="medicine.drug_code"
                    label="Complete Drug Name"
                    :items="medicineLib"
                    item-value="drug_code"
                    item-text="description"
                    :rules="[(v) => !!v || 'Complete Drug Name is required']"
                    outlined
                    hide-details
                    clearable
                  />
                  <v-text-field
                    v-else
                    v-model="medicine.generic"
                    label="Generic Name/Salt/Strength/Form/Unit/Package"
                    :rules="[
                      (v) =>
                        !!v ||
                        'Generic Name/Salt/Strength/Form/Unit/Package is required',
                    ]"
                    auto-grow
                    clearable
                    outlined
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="4">
                  <v-textarea
                    v-model="medicine.route"
                    auto-grow
                    clearable
                    outlined
                    label="Route"
                    row-height="1"
                    rows="1"
                    hide-details
                    :rules="[(v) => !!v || 'Route is required']"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-textarea
                    v-model="medicine.frequency"
                    auto-grow
                    clearable
                    outlined
                    hide-details
                    label="Frequency"
                    row-height="1"
                    rows="1"
                    :rules="[(v) => !!v || 'Frequency is required']"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    type="number"
                    outlined
                    v-model="medicine.quantity"
                    label="Quantity"
                    hide-details
                    :rules="[(v) => !!v || 'Quantity is required']"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-text-field
                    type="number"
                    outlined
                    v-model="medicine.cost"
                    label="Total Amount Price"
                    hide-details
                    :rules="[(v) => !!v || 'Total Amount Price is required']"
                  />
                </v-col>
              </v-row>
              <v-divider />
              <v-row>
                <v-col>
                  <v-btn
                    @click="addRow"
                    color="success"
                    class="ma-2 float-md-right"
                  >
                    <v-icon>mdi-plus</v-icon>
                    Add medicine
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-simple-table>
                    <thead>
                      <tr>
                        <th class="text-left">Drug Description</th>
                        <th class="text-left">Route</th>
                        <th class="text-left">Frequency</th>
                        <th class="text-left">Quantity</th>
                        <th class="text-left">Total Amount Price</th>
                        <th class="text-left">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(item, index) in formData.medicine"
                        :key="index"
                      >
                        <td v-if="item.is_pndf">
                          {{
                            description[index]
                              ? description[index].description
                              : ""
                          }}
                        </td>
                        <td v-else>
                          {{ item.generic }}
                        </td>
                        <td>{{ item.route }}</td>
                        <td>{{ item.frequency }}</td>
                        <td>{{ item.quantity }}</td>
                        <td>{{ item.cost }}</td>
                        <td>
                          <v-btn
                            @click="remove(index)"
                            x-small
                            fab
                            dark
                            color="red"
                          >
                            <v-icon>mdi-window-close</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </v-simple-table>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions right>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="currentTab === 0"
            @click="backTab"
            color="info"
            class="mr-4"
          >
            BACK
          </v-btn>
          <v-btn @click="validate" color="success" class="mr-4"> SAVE </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>

    <v-container v-else style="text-align: center">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
        >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    currentTab: Number,
    formData: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      medicineLib: [],
      medicine: {},
      description: [],
      loading: true,
    };
  },

  methods: {
    validate() {
      this.$snotify.confirm("Are you sure you want to save?", "Confirm", {
        timeout: 5000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        buttons: [
          {
            text: "Yes",
            action: (toast) => {
              this.save();
              this.$snotify.remove(toast.id);
            },
            bold: false,
          },
          {
            text: "Close",
            action: (toast) => this.$snotify.remove(toast.id),
            bold: true,
          },
        ],
      });
    },
    reset() {
      this.$refs.form.reset();
    },
    backTab() {
      this.$bus.emit("nextTab", this.currentTab - 1);
    },

    addRow() {
      if (this.$refs.form.validate()) {
        this.formData.medicine.push({
          drug_code: this.medicine.drug_code,
          generic: this.medicine.generic,
          quantity: this.medicine.quantity,
          route: this.medicine.route,
          frequency: this.medicine.frequency,
          cost: this.medicine.cost,
          is_pndf: this.medicine.is_pndf,
        });
        this.getDrugDescription();
        this.reset();
      }
    },
    remove(index) {
      this.formData.medicine.splice(index, 1);
      this.getDrugDescription();
    },

    getDrugDescription() {
      this.axios
        .post("medicine-description", this.formData.medicine, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN"),
          },
        })
        .then((response) => {
          // handle success
          this.description = [];
          this.description = response.data;
          this.loading = false;
        });
    },

    getMedicineLib() {
      this.axios
        .get("medicine-lib", {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN"),
          },
        })
        .then((response) => {
          // handle success
          this.medicineLib = response.data;
        })
        .catch((error) => {
          // handle error
          console.error(error);
        })
        .finally(() => {
          // always executed
        });
    },

    save() {
      let url = !this.formData.patient.id ? "save" : "update";
      this.axios
        .post(url, this.formData, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("AUTH_TOKEN"),
          },
        })
        .then((response) => {
          if (response.data.success) {
            let notif = this.$snotify.success(
              response.data.message,
              "Success!",
              {
                timeout: 5000,
                showProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
              }
            );
            notif.on("hidden", () =>
              this.$router.push({
                path: "/list",
              })
            );
          } else {
            let notif = this.$snotify.error(response.data.message, "Error!", {
              timeout: 5000,
              showProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
            });
          }
        })
        .catch((error) => {
          // handle error
          this.$snotify.error(error, "Error!", {
            timeout: 5000,
            showProgressBar: true,
            closeOnClick: false,
            pauseOnHover: false,
          });
          console.error(error);
        });
    },
  },

  mounted() {
    this.getMedicineLib();
    this.getDrugDescription();
  },
};
</script>

<style scoped>
.drug-code-label {
  color: #545b62;
  font-size: small;
}
</style>
